export default __webpack_public_path__ + "static/media/not-found.676fef04.jpg";